import { useEffect, useState } from "react";

import { ApiCallStatus, ApiEndpoints, ApiResponse, getApiClient } from "../../api-http";
import { getApiLocale } from "../../api-http/get-api-locale";
import { useAuthContext } from "../../auth";
import { useLocaleContext } from "../../i18n/locale-context";
import { EventSubscription } from "./types";

export function useGetSubscriptions(): [EventSubscription[], ApiCallStatus] {
  const { logged, userInfo, checking } = useAuthContext();
  const { locale } = useLocaleContext();
  const apiLocale = getApiLocale(locale);
  const [subscriptions, setSubscriptions] = useState<EventSubscription[]>([]);
  const [status, setStatus] = useState<ApiCallStatus>(ApiCallStatus.LOADING);

  useEffect(() => {
    if (checking) setStatus(ApiCallStatus.LOADING);
    else if (logged && userInfo?.sub) {
      getApiClient()
        .get<ApiResponse<EventSubscription[]>>(`${ApiEndpoints.SUBSCRIPTIONS}/${userInfo.sub}`, {
          headers: {
            "Accept-Language": apiLocale,
          },
        })
        .then((response) => {
          setSubscriptions(response.data.data ?? []);
          setStatus(ApiCallStatus.SUCCESS);
          return response;
        })
        .catch((e) => {
          setStatus(ApiCallStatus.FAILED);
          console.log(e);
        });
    } else setStatus(ApiCallStatus.FAILED);
  }, [locale, logged, checking, userInfo?.sub, apiLocale]);

  return [subscriptions, status];
}
